<ideal-app-header-button [class.active]="open()">
  <ideal-lottie icon src="assets/icons/menu-icon.json" speed="1.5" (loaded)="lottieLoaded()"></ideal-lottie>
</ideal-app-header-button>
